import { configureStore } from '@reduxjs/toolkit';
import { authSlice } from '@/store/slices/authSlice';
import { themeSlice } from '@/store/slices/themeSlice';
import { loadingSlice } from '@/store/slices/loadingSlice';
import { companySlice } from '@/store/slices/companySlice';
import { customerSlice } from '@/store/slices/customerSlice';
import { supplierSlice } from '@/store/slices/supplierSlice';
import { materialSlice } from '@/store/slices/materialSlice';
import { purchaseOrderSlice } from '@/store/slices/purchaseOrderSlice';
import { workProcessSlice } from '@/store/slices/workprocessSlice';
import { userSlice } from '@/store/slices/userSlice';
import { activityLogSlice } from '@/store/slices/activityLogSlice';
import { statusEnquirySlice } from '@/store/slices/statusEnquirySlice';
// import { academicSlice } from '@/store/slices/academicSlice';
// import { subjectSlice } from '@/store/slices/subjectSlice';
// import subjectStandardMappingReducer from '@/store/slices/subjectStandardMappingSlice';
// import subjectCategoryMappingReducer from '@/store/slices/subjectCategoryMappingSlice';
// import onboardingReducer from '@/store/slices/onboardingSlice';
// import { staffSlice } from '@/store/slices/staffSlice';
// import { studentSlice } from '@/store/slices/studentSlice';
// import assignClassesReducer from '@/store/slices/assignClassesSlice';
// import timeslotReducer from '@/store/slices/timeslotSlice';
// import { attendanceSlice } from '@/store/slices/attendanceSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    theme: themeSlice.reducer,
    loading: loadingSlice.reducer,
    company: companySlice.reducer,
    customer: customerSlice.reducer,
    supplier: supplierSlice.reducer,
    material: materialSlice.reducer,
    purchaseOrder: purchaseOrderSlice.reducer,
    workProcess: workProcessSlice.reducer,
    user: userSlice.reducer,
    activityLog: activityLogSlice.reducer,
    statusEnquiry: statusEnquirySlice.reducer,
    // academic: academicSlice.reducer,
    // subject: subjectSlice.reducer,
    // subjectStandardMapping: subjectStandardMappingReducer,
    // subjectCategoryMapping: subjectCategoryMappingReducer,
    // onboarding: onboardingReducer,
    // staff: staffSlice.reducer,
    // student: studentSlice.reducer,
    // assignClasses: assignClassesReducer,
    // timeslot: timeslotReducer,
    // attendance: attendanceSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Re-export types 
export type { RootState, AppDispatch } from '@/store/types';

// Export actions and async thunks
export { toggleTheme, setTheme, setPrimaryColor, setSecondaryColor, setCustomColors } from '@/store/slices/themeSlice';
export { clearError, setUser, setToken, clearAuth, loginUser, fetchProfile, logoutUser } from '@/store/slices/authSlice';
export { setLoading, setBackdropLoading, showLoader, hideLoader } from '@/store/slices/loadingSlice';
export { 
  fetchCompanies, 
  createCompany, 
  updateCompany, 
  deleteCompany, 
  fetchCompanyById,
  clearCompany,
  setCompanies 
} from '@/store/slices/companySlice';
export { 
  fetchCustomers, 
  createCustomer, 
  updateCustomer, 
  deleteCustomer, 
  fetchCustomerById,
  clearCustomer,
  setCustomers 
} from '@/store/slices/customerSlice';
export { 
  fetchSuppliers, 
  createSupplier, 
  updateSupplier, 
  deleteSupplier, 
  fetchSupplierById,
  clearSupplier,
  setSuppliers 
} from '@/store/slices/supplierSlice';
export {
  fetchMaterials,
  fetchMaterialsList,
  fetchMaterialsByGst,
  createMaterial,
  createBulkMaterials,
  updateMaterial,
  deleteMaterial,
  fetchMaterialById,
  clearMaterial,
  setMaterials
} from '@/store/slices/materialSlice';
export { 
  fetchPurchaseOrders, 
  createPurchaseOrder, 
  updatePurchaseOrder, 
  deletePurchaseOrder,
  fetchPurchaseOrderById,
  clearError as clearPurchaseOrderError
} from '@/store/slices/purchaseOrderSlice';
export {
  fetchWorkProcessSummary,
  createWorkProcess,
  updateWorkProcess,
  clearError as clearWorkProcessError,
  clearWorkProcessSummary
} from '@/store/slices/workprocessSlice';
export {
  fetchUsers,
  createUser,
  updateUser,
  deleteUser,
  fetchUserById,
  updateUserStatus,
  updateUserPassword,
  restoreUser,
  clearError as clearUserError,
  clearUser,
  setUsers
} from '@/store/slices/userSlice';
export {
  fetchActivityLogs,
  clearError as clearActivityLogError,
  clearActivityLogs
} from '@/store/slices/activityLogSlice';
export {
  fetchStatusEnquiries,
  createStatusEnquiry,
  updateStatusEnquiry,
  deleteStatusEnquiry,
  fetchStatusEnquiryById,
  clearError as clearStatusEnquiryError,
  clearStatusEnquiry,
  setStatusEnquiries
} from '@/store/slices/statusEnquirySlice';
